export const isInsideBrowser = (() => typeof window !== 'undefined')();

export const isMobileBrowser = () => {
  if (!isInsideBrowser) return false;
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i,
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
};

export const isEmmaApp = (() => {
  if (!isInsideBrowser) return false;
  return /EMMA( [A-Za-z]+)?\/([0-9]+\.){3}[0-9]{8,10}/g.test(
    navigator.userAgent,
  );
})();

export const isTabletDevice = (() => {
  if (!isInsideBrowser) return false;
  const userAgent = navigator.userAgent.toLowerCase();
  const isTablet =
    /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent,
    );
  return isTablet;
})();

export const platformStr = (() => {
  if (isEmmaApp) {
    return 'APP';
  } else if (isTabletDevice) {
    return 'TABLET';
  } else {
    return 'WEB';
  }
})();

export const deviceType = (() => {
  if (isEmmaApp) {
    return 'm'; // Mobile
  } else if (isTabletDevice) {
    return 't'; // Tablet
  } else {
    return 'd'; // Desktop
  }
})();

export const nameof = <T>(name: keyof T) => name;

export const getLang = () => {
  try {
    if (location.href.indexOf('zh/') >= 0) {
      return 'zh';
    }
    return 'en';
  } catch (e) {
    return 'en';
  }
};

export const getPlatformOS = (): 'android' | 'ios' | 'web' => {
  if (
    'getPlatformOS' in window &&
    typeof window.getPlatformOS === 'function' &&
    isEmmaApp
  ) {
    return window.getPlatformOS();
  }
  return 'web';
};

export const isInsideChatbot = () => {
  return window.location.href.includes('chatbot');
};

// the following five functions for upload documents
export const isEmmaVersionAtLeast = ({
  currentVersion,
  minVersion,
}: {
  currentVersion: string;
  minVersion: string;
}): boolean => {
  if (!currentVersion || !minVersion) return false;

  const current = currentVersion.split('.').map(Number);
  const min = minVersion.split('.').map(Number);

  // Validate version format
  if (
    current.length !== 3 ||
    min.length !== 3 ||
    current.some(isNaN) ||
    min.some(isNaN)
  ) {
    return false;
  }

  // Compare version parts in order
  for (let i = 0; i < 3; i++) {
    if (current[i] !== min[i]) {
      return current[i] > min[i];
    }
  }
  return true;
};

export const getFileExt = (fileName: string) => {
  return (fileName?.split('.')?.pop?.() || '').toLowerCase();
};

/**
 * Replace [target] in content with singular or plural based on the count
 */
export const pluralize = ({
  content,
  target,
  count,
  singular,
  plural,
}: {
  content: string;
  target: string;
  count: number;
  singular: string;
  plural: string;
}) => {
  if (!content) return '';
  return content.replace(`[${target}]`, count === 1 ? singular : plural);
};

/**
 * Replace [files] in content with 'file' or 'files' based on the count
 */
export const pluralizeFileLabel = (content: string, count: number) =>
  pluralize({
    content,
    target: 'files',
    count,
    singular: 'file',
    plural: 'files',
  });

export const getPureSubmissionField = (submissionField = '') => {
  const key = submissionField.replace('(optional)', '');
  const submissionFieldHasExtraPrefix = key.includes(':');
  const submissionFieldHasIndex = key.includes('#');

  return submissionFieldHasExtraPrefix
    ? key.split(':').pop()
    : submissionFieldHasIndex
    ? key.split('#').pop()
    : submissionField;
};

export const isIosSafariBrowser = () => {
  if (!isInsideBrowser) return false;
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  const isSafari = !!ua.match(/Safari/i);
  return iOS && webkit && isSafari;
};
